import FileSaver from 'file-saver';
import PropTypes from 'prop-types';
import ExcelJS from 'exceljs';
import IconExcel from '../Icon/IconExcel';
import { useGetProductSpecDataMutation } from '../../store/services/api';

const NewSingleExcelExporter = ({ excelData, customerName, projectName, isMetric }) => {
    const fileExtension = '.xlsx';
    const [triggerProductSpec] = useGetProductSpecDataMutation();

    const getTopLineDescription = async () => {
        const result = await triggerProductSpec(excelData.product_id);
        return result.data;
    }

    const exportToExcel = async () => {
        const currentDate = new Date().toDateString();
        try {
            const topLine = await getTopLineDescription();
            // Create a workbook and add a worksheet
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Report');

            const row1 = worksheet.getRow(1);
            row1.height = 120;

            const row2 = worksheet.getRow(2);
            row2.height = 23;
            const row3 = worksheet.getRow(3);
            row3.height = 23;
            const row4 = worksheet.getRow(4);
            row4.height = 23;
            const row5 = worksheet.getRow(5);
            row5.height = 23;
            const row6 = worksheet.getRow(6);
            row6.height = 23;

            const row8 = worksheet.getRow(8);
            row8.height = 23;
            const row9 = worksheet.getRow(9);
            row9.height = 23;
            const row10 = worksheet.getRow(10);
            row10.height = 23;
            const row11 = worksheet.getRow(11);
            row11.height = 23;
            const row12 = worksheet.getRow(12);
            row12.height = 23;
            const row13 = worksheet.getRow(13);
            row13.height = 23;
            const row14 = worksheet.getRow(14);
            row14.height = 23;
            const row15 = worksheet.getRow(15);
            row15.height = 23;
            const row16 = worksheet.getRow(16);
            row16.height = 23;
            const row17 = worksheet.getRow(17);
            row17.height = 23;
            const row18 = worksheet.getRow(18);
            row18.height = 23;
            const row19 = worksheet.getRow(19);
            row19.height = 23;
            const row20 = worksheet.getRow(20);
            row20.height = 23;
            const row21 = worksheet.getRow(21);
            row21.height = 80;

            const columnA = worksheet.getColumn('A');
            columnA.width = 5;
            const columnB = worksheet.getColumn('B');
            columnB.width = 30;
            const columnC = worksheet.getColumn('C');
            columnC.width = 40;
            const columnD = worksheet.getColumn('D');
            columnD.width = 15;

            worksheet.mergeCells('A1:B1');
            worksheet.mergeCells('A2:B2');
            worksheet.mergeCells('A3:B3');
            worksheet.mergeCells('A4:B4');
            worksheet.mergeCells('A5:B5');
            worksheet.mergeCells('A6:D6');
            worksheet.mergeCells('A7:D7');
            const row7 = worksheet.getRow(7);
            row7.height = 120;
            worksheet.mergeCells('A8:D8');
            worksheet.mergeCells('A9:A11');
            worksheet.mergeCells('A12:A14');
            worksheet.mergeCells('A15:A16');
            worksheet.mergeCells('A17:B17');
            worksheet.mergeCells('A18:B18');
            worksheet.mergeCells('A19:B19');
            worksheet.mergeCells('A20:B20');
            worksheet.mergeCells('A21:D21');
            worksheet.mergeCells('A22:D22');

            worksheet.mergeCells('C2:D2');
            worksheet.mergeCells('C3:D3');
            worksheet.mergeCells('C4:D4');
            worksheet.mergeCells('C5:D5');
            // A6:D6 merged on the top
            // A7:D7 merged on the top
            // A8:D8 merged on the top
            worksheet.mergeCells('C9:D9');
            worksheet.mergeCells('C10:D10');
            worksheet.mergeCells('C11:D11');
            worksheet.mergeCells('C12:D12');
            worksheet.mergeCells('C13:D13');
            worksheet.mergeCells('C14:D14');
            worksheet.mergeCells('C15:D15');
            worksheet.mergeCells('C16:D16');
            worksheet.mergeCells('C17:D17');
            worksheet.mergeCells('C18:D18');
            worksheet.mergeCells('C19:D19');
            worksheet.mergeCells('C20:D20');

            // add image to workbook by base64
            const myBase64Image = "data:image/png;base64,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";
            const imageId3 = workbook.addImage({
                base64: myBase64Image,
                extension: 'png',
            });

            worksheet.addImage(imageId3, {
                tl: { col: 0, row: 0 },
                br: { col: 2, row: 1 }
            });

            const c1Style = {
                alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
                font: { color: { argb: '0d3857' } },
            }
            const cellC1 = worksheet.getCell('C1');
            cellC1.value = 'PERFORMANCE DATA IMPERIAL';
            cellC1.style = c1Style;

            const d1Style = {
                alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
            }
            const cellD1 = worksheet.getCell('D1');
            cellD1.value = '800 Park Drive Owatonna, MN 55060 800.533.2080 viracon.com';
            cellD1.style = d1Style;

            const a2Style = {
                alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
                fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '0079c1' }},
                font: { color: { argb: 'FFFFFFFF' } },
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellA2 = worksheet.getCell('A2');
            cellA2.value = 'Created by:';
            cellA2.style = a2Style;

            const a3Style = {
                alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
                fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '128acb' }},
                font: { color: { argb: 'FFFFFFFF' } },
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellA3 = worksheet.getCell('A3');
            cellA3.value = 'Project Name:';
            cellA3.style = a3Style;

            const a4Style = {
                alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
                fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '4594d0' }},
                font: { color: { argb: 'FFFFFFFF' } },
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellA4 = worksheet.getCell('A4');
            cellA4.value = 'Customer Name:';
            cellA4.style = a4Style;

            const a5Style = {
                alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
                fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '639fd6' }},
                font: { color: { argb: 'FFFFFFFF' } },
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellA5 = worksheet.getCell('A5');
            cellA5.value = 'Date:';
            cellA5.style = a5Style;

            const a6Style = {
                alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
                fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '0d3857' }},
                font: { color: { argb: 'FFFFFFFF' } },
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellA6 = worksheet.getCell('A6');
            cellA6.value = 'Product Name';
            cellA6.style = a6Style;

            // Product Space
            const a7Style = {
                alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
                fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'edf0f2' }},
                font: { color: { argb: '000000' } },
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellA7 = worksheet.getCell('A7');
            cellA7.style = a7Style;

            const a8Style = {
                alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
                fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '0d3857' }},
                font: { color: { argb: 'FFFFFFFF' } },
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellA8 = worksheet.getCell('A8');
            cellA8.value = '';
            cellA8.style = a8Style;

            // Rotate the text from bottom to top and align it to the left side of the cell
            const bottomToTopAlignment = {
                textRotation: 90,
                vertical: 'top',
                horizontal: 'left',
            }

            const a9Style = {
                alignment: { textRotation: 90, horizontal: 'center', vertical: 'middle' },
                fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '0d3857' }},
                font: { color: { argb: 'FFFFFFFF' } },
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellA9 = worksheet.getCell('A9');
            cellA9.value = 'Transmission';
            cellA9.style = a9Style;

            const a12Style = {
                alignment: { textRotation: 90, horizontal: 'center', vertical: 'middle' },
                fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '3b6178' }},
                font: { color: { argb: 'FFFFFFFF' } },
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellA12 = worksheet.getCell('A12');
            cellA12.value = 'Reflectance';
            cellA12.style = a12Style;

            const a15Style = {
                alignment: { textRotation: 90, horizontal: 'center', vertical: 'middle' },
                fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '1f6e9e' }},
                font: { color: { argb: 'FFFFFFFF' } },
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellA15 = worksheet.getCell('A15');
            cellA15.value = 'U-Value';
            cellA15.style = a15Style;

            const a17Style = {
                alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
                fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '0079c1' }},
                font: { color: { argb: 'FFFFFFFF' } },
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellA17 = worksheet.getCell('A17');
            cellA17.value = 'Shading Coefficient';
            cellA17.style = a17Style;

            const a18Style = {
                alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
                fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '128acb' }},
                font: { color: { argb: 'FFFFFFFF' } },
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellA18 = worksheet.getCell('A18');
            cellA18.value = 'Solar Heat Gain';
            cellA18.style = a18Style;

            const a19Style = {
                alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
                fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '4594d0' }},
                font: { color: { argb: 'FFFFFFFF' } },
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellA19 = worksheet.getCell('A19');
            cellA19.value = 'Relative Heat Gain';
            cellA19.style = a19Style;

            const a20Style = {
                alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
                fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '639fd6' }},
                font: { color: { argb: 'FFFFFFFF' } },
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellA20 = worksheet.getCell('A20');
            cellA20.value = 'Light to Solar Gain';
            cellA20.style = a20Style;

            const b2Style = {
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellB2 = worksheet.getCell('B2');
            cellB2.style = b2Style;

            const b3Style = {
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellB3 = worksheet.getCell('B3');
            cellB3.style = b3Style;

            const b4Style = {
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellB4 = worksheet.getCell('B4');
            cellB4.style = b4Style;

            const b5Style = {
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellB5 = worksheet.getCell('B5');
            cellB5.style = b5Style;

            const b6Style = {
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellB6 = worksheet.getCell('B6');
            cellB6.style = b6Style;

            const b8Style = {
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellB8 = worksheet.getCell('B8');
            cellB8.style = b8Style;

            const b9Style = {
                alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
                fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '3d6078' }},
                font: { color: { argb: 'FFFFFFFF' } },
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellB9 = worksheet.getCell('B9');
            cellB9.value = 'Visible';
            cellB9.style = b9Style;

            const b10Style = {
                alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
                fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '557489' }},
                font: { color: { argb: 'FFFFFFFF' } },
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellB10 = worksheet.getCell('B10');
            cellB10.value = 'Solar';
            cellB10.style = b10Style;

            const b11Style = {
                alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
                fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '6e889a' }},
                font: { color: { argb: 'FFFFFFFF' } },
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellB11 = worksheet.getCell('B11');
            cellB11.value = 'UV';
            cellB11.style = b11Style;

            const b12Style = {
                alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
                fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '628193' }},
                font: { color: { argb: 'FFFFFFFF' } },
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellB12 = worksheet.getCell('B12');
            cellB12.value = 'Vis-Out';
            cellB12.style = b12Style;

            const b13Style = {
                alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
                fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '7690a0' }},
                font: { color: { argb: 'FFFFFFFF' } },
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellB13 = worksheet.getCell('B13');
            cellB13.value = 'Vis-In';
            cellB13.style = b13Style;

            const b14Style = {
                alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
                fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '89a0ae' }},
                font: { color: { argb: 'FFFFFFFF' } },
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellB14 = worksheet.getCell('B14');
            cellB14.value = 'Solar';
            cellB14.style = b14Style;

            const b15Style = {
                alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
                fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '4b8bb1' }},
                font: { color: { argb: 'FFFFFFFF' } },
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellB15 = worksheet.getCell('B15');
            cellB15.value = 'Winter';
            cellB15.style = b15Style;

            const b16Style = {
                alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
                fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '6299bb' }},
                font: { color: { argb: 'FFFFFFFF' } },
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellB16 = worksheet.getCell('B16');
            cellB16.value = 'Summer';
            cellB16.style = b16Style;

            const b17Style = {
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellB17 = worksheet.getCell('B17');
            cellB17.style = b17Style;

            const b18Style = {
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellB18 = worksheet.getCell('B18');
            cellB18.style = b18Style;

            const b19Style = {
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellB19 = worksheet.getCell('B19');
            cellB19.style = b19Style;

            const b20Style = {
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellB20 = worksheet.getCell('B20');
            cellB20.style = b20Style;

            /* Styling ends here */

            const generalResultStyle = {
                alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
                fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'edf0f2' }},
                font: { color: { argb: '000000' } },
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }

            const cellC2 = worksheet.getCell('C2');
            cellC2.value = 'N/A';
            cellC2.style = generalResultStyle;

            const cellC3 = worksheet.getCell('C3');
            cellC3.value = projectName;
            cellC3.style = generalResultStyle;

            const cellC4 = worksheet.getCell('C4');
            cellC4.value = customerName;
            cellC4.style = generalResultStyle;

            const cellC5 = worksheet.getCell('C5');
            cellC5.value = new Date().toLocaleString();
            cellC5.style = generalResultStyle;

            const cellC7 = worksheet.getCell('C7');
            cellC7.value = isMetric
                ? excelData.productMetric.split(';').join(';\n')
                : `${topLine?.top_line_imp.split(" as")[0]} \n ${(excelData.product.replace(/^[^;]*;\s*/, '')).split(';').join(';\n')}`;
            cellC7.style = generalResultStyle;

            const cellC9 = worksheet.getCell('C9');
            cellC9.value = `${excelData.description_visible}%`;
            cellC9.style = generalResultStyle;

            const cellC10 = worksheet.getCell('C10');
            cellC10.value = `${excelData.description_solar}%`;
            cellC10.style = generalResultStyle;

            const cellC11 = worksheet.getCell('C11');
            cellC11.value = `${excelData.description_uv}%`;
            cellC11.style = generalResultStyle;

            const cellC12 = worksheet.getCell('C12');
            cellC12.value = `${excelData.reflectance_out}%`;
            cellC12.style = generalResultStyle;

            const cellC13 = worksheet.getCell('C13');
            cellC13.value = `${excelData.reflectance_in}%`;
            cellC13.style = generalResultStyle;

            const cellC14 = worksheet.getCell('C14');
            cellC14.value = `${excelData.reflectance_solar}%`;
            cellC14.style = generalResultStyle;

            const cellC15 = worksheet.getCell('C15');
            cellC15.value = isMetric ? excelData.u_value_solar_metric : excelData.u_value_solar;
            cellC15.style = generalResultStyle;

            const cellC16 = worksheet.getCell('C16');
            cellC16.value = isMetric ? excelData.u_value_summer_metric : excelData.u_value_summer;
            cellC16.style = generalResultStyle;

            const cellC17 = worksheet.getCell('C17');
            cellC17.value = excelData.shading_coefficient;
            cellC17.style = generalResultStyle;

            const cellC18 = worksheet.getCell('C18');
            cellC18.value = excelData.solar_heat_gain_coefficient;
            cellC18.style = generalResultStyle;

            const cellC19 = worksheet.getCell('C19');
            cellC19.value = isMetric ? excelData.relative_heat_gain_metric : excelData.relative_heat_gain;
            cellC19.style = generalResultStyle;

            const cellC20 = worksheet.getCell('C20');
            cellC20.value = excelData.light_solar_gain_ration;
            cellC20.style = generalResultStyle;

            const dStyle = {
                border: {
                    top: {style:'medium', color: {argb:'FFFFFFFF'}},
                    left: {style:'medium', color: {argb:'FFFFFFFF'}},
                    bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                    right: {style:'medium', color: {argb:'FFFFFFFF'}}
                }
            }
            const cellD2 = worksheet.getCell('D2');
            cellD2.style = dStyle;

            const cellD3 = worksheet.getCell('D3');
            cellD3.style = dStyle;

            const cellD4 = worksheet.getCell('D4');
            cellD4.style = dStyle;

            const cellD5 = worksheet.getCell('D5');
            cellD5.style = dStyle;

            const cellD6 = worksheet.getCell('D6');
            cellD6.style = dStyle;

            const cellD8 = worksheet.getCell('D8');
            cellD8.style = dStyle;

            const cellD9 = worksheet.getCell('D9');
            cellD9.style = dStyle;

            const cellD10 = worksheet.getCell('D10');
            cellD10.style = dStyle;

            const cellD11 = worksheet.getCell('D11');
            cellD11.style = dStyle;

            const cellD12 = worksheet.getCell('D12');
            cellD12.style = dStyle;

            const cellD13 = worksheet.getCell('D13');
            cellD13.style = dStyle;

            const cellD14 = worksheet.getCell('D14');
            cellD14.style = dStyle;

            const cellD15 = worksheet.getCell('D15');
            cellD15.style = dStyle;

            const cellD16 = worksheet.getCell('D16');
            cellD16.style = dStyle;

            const cellD17 = worksheet.getCell('D17');
            cellD17.style = dStyle;

            const cellD18 = worksheet.getCell('D18');
            cellD18.style = dStyle;

            const cellD19 = worksheet.getCell('D19');
            cellD19.style = dStyle;

            const cellD20 = worksheet.getCell('D20');
            cellD20.style = dStyle;

            const a21Style = {
                alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
                fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '0d3857' }},
                font: { color: { argb: 'FFFFFFFF' } },
            }

            const a22Style = {
                alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
                fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '0d3857' }},
                font: { color: { argb: 'FFFFFFFF' }, bold: true },
            }

            const cellA21 = worksheet.getCell('A21');
            cellA21.value = "Viracon's Performance Data is center of glass data based on National Fenestration Rating Council's (NFRC) measurement standards and is calculated using Lawrence Berkeley National Laboratory's (LBNL) WINDOW 7 software. Contact Viracon for product availability.";
            cellA21.style = a21Style;

            const cellA22 = worksheet.getCell('A22');
            cellA22.value = "Note: UltraViolet defined as 300 to 380 nanometers(nm)";
            cellA22.style = a22Style;

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const filename = `${currentDate}${fileExtension}`;
            FileSaver.saveAs(blob, filename);
        } catch (error) {
            console.error('Error exporting to Excel:', error);
        }
    };

    return (
        <button
            type="submit"
            onClick={(e) => exportToExcel()}
            className="p-2 group relative cursor-pointer"
            aria-label="Single Excel Export"
        >
            <IconExcel />
            <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-100 absolute bottom-full left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs py-1 px-1 rounded-md">
            Excel
            </span>
        </button>
    )
}

NewSingleExcelExporter.propTypes = {
    excelData: PropTypes.object.isRequired,
    customerName: PropTypes.string.isRequired,
    projectName: PropTypes.string.isRequired,
    isMetric: PropTypes.bool.isRequired,
}

export default NewSingleExcelExporter;